import React, { useEffect, useState, Fragment, lazy } from 'react';
import { AlertTriangleIcon, BoxIcon, ClockIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { ImagePlaceholder } from './ImagePlaceholder';
import { Mandala } from './HealingIcons';
import { Pricing } from './Pricing';
const modules = ['MÓDULO 1 — Dolor y Sistema Musculoesquelético · 15 fichas', 'MÓDULO 2 — Mente, Emociones y Sistema Nervioso · 10 fichas', 'MÓDULO 3 — Digestión, Inmunidad y Vitalidad · 10 fichas', 'MÓDULO 4 — Salud Femenina y Ciclos Hormonales · 8 fichas', 'MÓDULO 5 — Estética Facial y Relajación Profunda · 7 fichas', 'Guía Rápida de Síntomas — ¿Qué te duele? → Página exacta', 'Glosario Técnico — Terminología clínica en Pinyin'];
const bonuses = [{
  n: '01',
  title: 'El Canal del Infinito',
  description: 'Fisiología Energética y Reloj Biológico de los Meridianos',
  price: '$15.000',
  cover: 'https://cdn.magicpatterns.com/uploads/xxE1tfYm5krR7XEt4DcFGY/Portadaa_bono_1.png'
}, {
  n: '02',
  title: 'Psicosomática Oriental',
  description: 'El Mapa de las Emociones Atrapadas y los 5 Elementos',
  price: '$15.000',
  cover: 'https://cdn.magicpatterns.com/uploads/nxGNxRFdnMocPukjpDhErK/Portadaa_bono_2.png'
}, {
  n: '03',
  title: 'Maestría en Manipulación',
  description: 'Ciencia, Intención y Técnica de la Presión Energética',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/ceTrXq9do64t8B6UrhdAZm/Portadaa_bono_3.png'
}, {
  n: '04',
  title: 'Alquimia a través del Calor',
  description: 'Termoterapia y Moxibustión aplicada a los Puntos Maestros',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/9LSo774knV69Grq5kdKtiT/Portadaa_bono_4.png'
}, {
  n: '05',
  title: 'Auriculoterapia Clínica',
  description: 'El Microsistema del Pabellón Auricular: El mando a distancia de tu salud',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/ofYtwTvd3BZZ6cSg9dQotR/Portadaa_bono_5.png'
}, {
  n: '06',
  title: 'Farmacopea Externa',
  description: 'Sinergia Holística: Aceites Esenciales y Plantas aplicadas a los Puntos Maestros',
  price: '$10.000',
  cover: 'https://cdn.magicpatterns.com/uploads/iD81krjQxLfnCnFpAMT2E7/Portadaa_bono_6.png'
}];
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 56,
    s: 2
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const value = (number: number) => String(number).padStart(2, '0');
  return <div className="mx-auto mb-10 max-w-4xl" data-id="element-176" data-mp="2859g2yl9u0ra">
      <div className="rounded-3xl border-2 border-brand-gold/55 bg-brand-paper p-6 shadow-[0_14px_42px_rgba(34,54,70,0.1)] md:p-8" data-id="element-177" data-mp="286b19vw043mq">
        <div className="flex items-center justify-center gap-2 text-brand-ink" data-id="element-178" data-mp="1yfzn7gilse24">
          <ClockIcon className="h-5 w-5 text-brand-purple" data-id="element-179" data-mp="1ydvkv30crn3y" />
          <h3 className="font-serif text-lg font-bold md:text-xl" data-id="element-180" data-mp="23dhy3cg6l3cr">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mt-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-181" data-mp="1ue4omjs24es1">
          {[{
          number: timeLeft.h,
          label: 'Horas'
        }, {
          number: timeLeft.m,
          label: 'Min'
        }, {
          number: timeLeft.s,
          label: 'Seg'
        }].map((item, index) => <Fragment key={item.label} data-id="element-182" data-mp="3etzj8gebvjk3" data-mpi={index}>
              <div className="text-center" data-id="element-183" data-mp="3eswsq9kx3j4p">
                <div className="rounded-xl bg-brand-ink px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-paper md:px-5 md:py-3 md:text-4xl" data-id="element-184" data-mp="3erlqwfb18lg8">
                  {value(item.number)}
                </div>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-wider text-brand-muted" data-id="element-185" data-mp="15qs4u9d1l7i1">
                  {item.label}
                </span>
              </div>
              {index < 2 && <span className="mb-5 text-2xl font-bold text-brand-goldDark md:text-4xl" data-id="element-186" data-mp="vtdwyy56pr1c">
                  :
                </span>}
            </Fragment>)}
        </div>
        <div className="mt-5 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-surfaceLight px-4 py-3 text-center text-sm font-semibold text-brand-ink" data-id="element-187" data-mp="n0105l40259z">
          <AlertTriangleIcon className="h-4 w-4 shrink-0 text-brand-amber" data-id="element-188" data-mp="d2396pur9udo" />
          Después sube $25.000 ARS.{' '}
          <span className="text-brand-purple" data-id="element-189" data-mp="83063ayc5y8c">No vuelve.</span>
        </div>
        <div className="mt-5 rounded-2xl border border-brand-green/25 bg-brand-paper p-4" data-id="element-190" data-mp="3u4zesnp6zcvl">
          <div className="mb-3 flex items-center justify-between gap-4 text-sm" data-id="element-191" data-mp="2yfumhxguakm">
            <span className="font-semibold text-brand-text" data-id="element-192" data-mp="3094e63dlawu">
              Cupos al precio de lanzamiento
            </span>
            <span className="font-bold uppercase tracking-wide text-brand-purple" data-id="element-193" data-mp="cwc475ar8xgm">
              94% tomados
            </span>
          </div>
          <div className="h-2.5 overflow-hidden rounded-full bg-brand-greenSage" data-id="element-194" data-mp="3bfstqu0xe96m">
            <div className="h-full w-[94%] rounded-full bg-brand-forest" data-id="element-195" data-mp="3gedtksc9mquj" />
          </div>
          <p className="mt-2 text-center text-xs text-brand-muted" data-id="element-196" data-mp="3lc5jxhx9i4wm">
            <strong className="text-brand-purple" data-id="element-197" data-mp="3q35j6ttusz2a">94%</strong> de los cupos ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
export function PackContents() {
  return <Section id="method" className="relative" data-id="element-198" data-mp="2xmutat9mlqw7">
      <Mandala className="absolute -left-16 top-20 -z-10 h-52 w-52 opacity-10" color="#2E5946" data-id="element-199" data-mp="2xlt7puuzhm08" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-200" data-mp="2pkkc8nfit3za">
        <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-brand-forest" data-id="element-201" data-mp="2knlp4ou9xxal">
          <BoxIcon className="h-4 w-4" aria-hidden="true" data-id="element-202" data-mp="2zan7kua46u0s" />
          Qué incluye tu botiquín
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold text-brand-ink md:text-5xl" data-id="element-203" data-mp="2uddkhla76ug4">
          EBOOK PRINCIPAL
        </h2>
      </div>
      <div className="mx-auto mt-9 grid max-w-5xl items-start gap-8 rounded-3xl border border-brand-green/25 bg-brand-paper/80 p-5 shadow-[0_14px_40px_rgba(34,54,70,0.08)] md:grid-cols-[0.8fr_1.2fr] md:p-8" data-id="element-204" data-mp="21o7ojo21hob4">
        <div className="w-full max-w-[290px] justify-self-center overflow-hidden rounded-2xl bg-brand-paper shadow-[0_18px_36px_rgba(34,54,70,0.16)]" data-id="element-205" data-mp="2bmngtucsz3m7">
          <img src="https://cdn.magicpatterns.com/uploads/qQ5DvEbiQfTP9Qeo8U3nfn/Botiquin_ebook_solo_sin_fondo.png" alt="Portada del ebook El Botiquín Ancestral" loading="lazy" decoding="async" className="aspect-[3/4] w-full object-contain" data-id="element-206" data-mp="3rz2hx3iawo5s" />
        </div>
        <div data-id="element-207" data-mp="3ce8qeyxrjow">
          <span className="text-xs font-bold uppercase tracking-[0.16em] text-brand-purple" data-id="element-208" data-mp="3lkdie6v99imq">
            60 PÁGINAS · 50 FICHAS VISUALES 
          </span>
          <h3 className="mt-2 font-serif text-3xl font-bold text-brand-ink" data-id="element-209" data-mp="3pmh55rndk9nb">
            EL BOTIQUÍN ANCESTRAL™
          </h3>
          <p className="mt-4 leading-relaxed text-brand-text" data-id="element-210" data-mp="h8hz1x6ov7w3">
            El atlas visual de digitopuntura más completo y elegante del mercado
            hispanohablante.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-brand-muted" data-id="element-211" data-mp="8dlk0o0af10b">
            Cada ficha ocupa una página completa. Una imagen artística de alta
            definición que muestra el punto exacto, y una columna lateral con
            toda la información técnica que necesitás para aplicarlo en
            segundos.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-brand-text" data-id="element-212" data-mp="g4tz1aeg2x02">
            {modules.map(module => <li key={module} className="flex gap-2" data-id="element-213" data-mp="bdtzdxdxy0tv">
                <span className="font-bold text-brand-forest" data-id="element-214" data-mp="bcaiq5odhnrk">✓</span>
                <span data-id="element-215" data-mp="6g29f8wuwosb">{module}</span>
              </li>)}
          </ul>
        </div>
      </div>
      <div className="mt-14 text-center" data-id="element-216" data-mp="1hr0d0edyib5">
        <h3 className="flex items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-217" data-mp="z3y1u1fe7uja">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-218" data-mp="u54r2grhqhmt" />
          6 BONOS ESTRATÉGICOS —
          <span className="text-brand-goldDark" data-id="element-219" data-mp="p479a5ae7plu">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-220" data-mp="k65q7kcyvqad">
        {bonuses.map(bonus => <article key={bonus.n} className="min-w-0" data-id="element-221" data-mp="39tmxqtm5328b">
            <div className="aspect-[3/4] overflow-hidden rounded-xl border border-brand-gold/40 bg-brand-paper shadow-[0_8px_20px_rgba(34,54,70,0.12)]" data-id="element-222" data-mp="34w4w7oagbpac">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-223" data-mp="1pdp3jy4tkmt6" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-wide text-brand-purple" data-id="element-224" data-mp="1z5uvj7v2n48d">
              {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.75rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-225" data-mp="283ol7zybyzmk">
              {bonus.description}
            </p>
            <p className="mt-2 text-center text-[10px] text-brand-muted" data-id="element-226" data-mp="2d1q70sn55d1q">
              <span className="line-through" data-id="element-227" data-mp="2i246vnel9goo">{bonus.price}</span>{' '}
              <strong className="text-brand-forest" data-id="element-228" data-mp="iqjte1ifiew4">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-7 text-center" data-id="element-229" data-mp="np4stypuwuji">
        <span className="inline-block rounded-full border border-brand-gold/50 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-230" data-mp="r84o3ptrfi6w">
          Valor total bonos{' '}
          <span className="text-brand-muted line-through" data-id="element-231" data-mp="w9bubkg989bg">$76.000</span>{' '}
          <strong className="text-brand-forest" data-id="element-232" data-mp="114r5u5qsht4p">
            → GRATIS con tu Botiquín Ancestral
          </strong>
        </span>
      </div>
    </Section>;
}
export function MethodOverview() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-233" data-mp="1a6h51xqwxwd1">
      <LaunchUrgency data-id="element-234" data-mp="1f5brras0452f" />
      <Pricing data-id="element-235" data-mp="1f4iowkw5xzpk" />
    </div>;
}